import React from "react";
import Modal from "react-bootstrap/Modal";

const ConfirmationModal = ({
  show,
  onHide,
  onConfirm,
  title,
  message,
  cancelButtonText,
  confirmButtonText,
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{message}</Modal.Body>
      <Modal.Footer style={{ gap: "1rem" }}>
        <button onClick={onHide}>{cancelButtonText}</button>
        <button onClick={onConfirm}>{confirmButtonText}</button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;
